<span>
  <div class="ae-content-toast">
    <div class="ae-content-toast-load" style="width: {{percentageLoad}}% !important"></div>
    <div class="ae-content-toast-info">
      <p>
        {{ message }}
      </p>
      <span (click)="setClose()">
        <img src="assets/img/icons/close.svg">
      </span>
    </div>
    
  </div>
</span>
